import { deleteTechnicalAssistanceModule } from '../../config/apiSinToken'

/**
 * AUTHOR: gdgerandez@ngshn.com
 * DESCRIPTION: Eliminar solicitantes para asistencia tecnica
 * FECHA: 01-02-2023
 */
export const deleteTechnicalAssistanceApplicant = async (params) => {
  const data = await deleteTechnicalAssistanceModule(
    `api/v1/TechnicalAssistanceApplicant/delete/${params}`,
  )
  return data
}

/**
 * AUTHOR: gdgerandez@ngshn.com
 * DESCRIPTION: Eliminar  asistencia tecnica recibida
 * FECHA: 02-02-2023
 */
export const deleteTechnicalAssistanceReceived = async (params) => {
  const data = await deleteTechnicalAssistanceModule(
    `api/v1/TechnicalAssistanceReceived/delete/${params}`,
  )
  return data
}

/**
 * AUTHOR: gdgerandez@ngshn.com
 * DESCRIPTION: Eliminar  asistencia tecnica recibida
 * FECHA: 02-02-2023
 */
export const deleteTechnicalAssistanceImplementationActivities = async (
  params,
) => {
  const data = await deleteTechnicalAssistanceModule(
    `api/v1/ImplementationActivities/delete/${params}`,
  )
  return data
}

/**
 * AUTHOR: gdgerandez@ngshn.com
 * DESCRIPTION: Eliminar comunidad indigena
 * FECHA: 03-02-2023
 */
export const deleteIndigenousCommunities = async (params) => {
  const data = await deleteTechnicalAssistanceModule(
    `api/v1/IndigenousCommunities/delete/${params}`,
  )
  return data
}

/**
 * AUTHOR: gdgerandez@ngshn.com
 * DESCRIPTION: Eliminar categoria de asistencia tecnica
 * FECHA: 14-02-2023
 */
export const deleteITechnicalAssistanceBudget = async (params) => {
  const data = await deleteTechnicalAssistanceModule(
    `api/v1/TechnicalAssistanceBudget/delete/${params}`,
  )
  return data
}

/**
 * AUTHOR: gdgerandez@ngshn.com
 * DESCRIPTION: Eliminar Applied studies
 * FECHA: 23-02-2023
 */
export const deleteAppliedStudies = async (params) => {
  const data = await deleteTechnicalAssistanceModule(
    `api/v1/AppliedStudies/delete/${params}`,
  )
  return data
}

/**
 * AUTHOR: gdgerandez@ngshn.com
 * DESCRIPTION: Eliminar Provider List
 * FECHA: 13-03-2023
 */
export const deleteProviderList = async (params) => {
  const data = await deleteTechnicalAssistanceModule(
    `api/v1/ProviderList/delete/${params}`,
  )
  return data
}

/**
 * AUTHOR: gdgerandez@ngshn.com
 * DESCRIPTION: Eliminar borrador
 * FECHA: 12-04-2023
 */
export const deleteFormTechnicalAssistanceAnswers = async (
  idForm,
  idUserB2C,
) => {
  const data = await deleteTechnicalAssistanceModule(
    `api/v1/TechnicalAssistanceAnswers/DeleteForm/${idForm}/${idUserB2C}`,
  )
  return data
}
